module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/CentralJuvie-5_BW-p-500-066ecb2fbc717ee1b6bbf32f824b0a95.jpg";